<template>
  <div>
    <v-form @submit.prevent="change">
      <v-card>
        <v-card-title>Change password</v-card-title>
        <v-card-text>Here you can change your password. Use the strong passwords to avoid leaking your data.</v-card-text>
        <v-card-actions>
          <v-row>
            <v-col>
              <v-text-field
                label="Old password"
                placeholder="Old password"
                outlined rounded
                :type="showOldPassword ? 'text' : 'password'"
                :disabled="loading"
                v-model="oldPassword"
                :rules="[validations.required]"
                :append-icon="showOldPassword ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append="showOldPassword = !showOldPassword"
              />

              <v-text-field
                label="New password"
                placeholder="New password"
                outlined rounded
                :type="showNewPassword ? 'text' : 'password'"
                :disabled="loading"
                v-model="newPassword"
                :rules="[validations.required]"
                :append-icon="showNewPassword ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append="showNewPassword = !showNewPassword"
              />
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>

      <br/>
      <v-row>
        <v-col :cols="isMobile ? 12 : 2">
          <v-btn
            :block="isMobile"
            type="submit"
            color="primary"
            x-large
            rounded
            min-width="250"
            :disabled="disabledBtn"
          >
            Change password
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import {isMobileMixin, textFieldsValidations} from "@/mixins";

export default {
  name: "ChangePassword",
  mixins: [isMobileMixin, textFieldsValidations],
  data() {
    return {
      oldPassword: '',
      newPassword: '',
      showOldPassword: false,
      showNewPassword: false,
    }
  },
  computed: {
    ...mapState(['loading', 'profile']),
    disabledBtn() {
      return !this.newPassword || !this.oldPassword || this.loading || (this.newPassword === this.oldPassword)
    }
  },

  async mounted() {
    if (!this.profile) await this.getProfile()
  },

  methods: {
    ...mapActions(['getProfile', 'updateProfile']),
    async change() {
      if (!this.newPassword || !this.oldPassword) return
      await this.updateProfile({
        old_password: this.oldPassword,
        new_password: this.newPassword,
      })
      this.oldPassword = ''
      this.newPassword = ''
    },
  }
}
</script>

<style scoped>

</style>